import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Navbar from './components/layout/Navbar';
import Home from './pages/Home';
import MapView from './pages/MapView';
import JobDetails from './pages/JobDetails';
import Login from './pages/employer/Login';
import Dashboard from './pages/employer/Dashboard';
import PostJob from './pages/employer/PostJob';
import ForgotPassword from './pages/employer/ForgotPassword';
import UpdatePassword from './pages/employer/UpdatePassword';
import AdminDashboard from './pages/admin/AdminDashboard';
import NewsletterArchive from './pages/NewsletterArchive';
import NewsletterDetail from './pages/NewsletterDetail';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col font-sans selection:bg-emerald-100 selection:text-emerald-900">
          <Navbar />
          <main className="flex-1 flex flex-col">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/map" element={<MapView />} />
              <Route path="/jobs/:id" element={<JobDetails />} />
              <Route path="/employer/login" element={<Login />} />
              <Route path="/employer/dashboard" element={<Dashboard />} />
              <Route path="/employer/post-job" element={<PostJob />} />
              <Route path="/employer/edit-job/:id" element={<PostJob />} />
              <Route path="/employer/forgot-password" element={<ForgotPassword />} />
              <Route path="/employer/update-password" element={<UpdatePassword />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/newsletters" element={<NewsletterArchive />} />
              <Route path="/newsletters/:slug" element={<NewsletterDetail />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;